





































































import { Component } from '@niknevis/vue-modules/decorators'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import Vue from 'vue'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import Checkbox from '@/modules/shared/components/shared/kit/Checkbox.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'

@Component({
  layout: PanelLayout,
  metaInfo: {
    title: 'شرایط و قوانین'
  },
  components: {
    BaseButton,
    Checkbox,
    BaseCard,
    AdminLayout,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends Vue {
  constructor(
  ) {
    super()
  }

  termConfirm: boolean = false

  onSubmit() {
  }
}

